import { Button } from "@progress/kendo-react-buttons";
import { DropDownList, type DropDownListChangeEvent } from "@progress/kendo-react-dropdowns";
import type { GridFilterCellProps } from "@progress/kendo-react-grid";
import { filterClearIcon } from "@progress/kendo-svg-icons";
import { useCallback } from "react";

interface DropDownFilterCellProps extends GridFilterCellProps {
    defaultItem: string;
    data: string[];
}

export const DropDownFilterCell = (props: DropDownFilterCellProps) => {
    const { data, defaultItem, value, onChange } = props;

    const hasNonDefaultValue = useCallback((value: string | undefined): boolean =>
        Boolean(value && value !== defaultItem),
    [defaultItem]
    );

    const handleChange = useCallback((event: DropDownListChangeEvent) => {
        const value = event.target.value as string;
        const hasValue = hasNonDefaultValue(value);
        onChange({
            value: hasValue ? event.target.value : "",
            operator: hasValue ? "eq" : "",
            syntheticEvent: event.syntheticEvent
        });
    }, [hasNonDefaultValue, onChange]);

    const handleClear = useCallback((e: React.MouseEvent) => {
        e.preventDefault();
        onChange({ value: "", operator: "", syntheticEvent: e });
    },
    [onChange]);

    return (
        <div className="k-filtercell">
            <DropDownList
                data={data}
                onChange={handleChange}
                value={value || defaultItem}
                defaultItem={defaultItem}
            />
            <Button
                title="Clear"
                disabled={!hasNonDefaultValue(value)}
                onClick={handleClear}
                svgIcon={filterClearIcon}
            />
        </div>
    );
};
